import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  border: '0.3px solid #B9B9B9',
  borderRadius: 14,
  padding: '0 0 30px',
  minHeight: '50vh',
  background: 'white',
  marginBottom: 30
});

export const Head = styled('div')({
  padding: '11px 33px',
  borderRadius: '14px 14px 0 0',
  background: '#FCFDFD',
  borderBottom: '0.3px solid #B9B9B9',
  fontWeight: 500,
  fontSize: 18
});

export const Footer = styled('div')({
  marginTop: 'auto',
  alignSelf: 'flex-end',
  padding: '0 33px 0',

  '& button': {
    minWidth: 120,
    padding: '12px 0'
  }
});

export const Content = styled('div')({
  paddingTop: 10
});
